module.exports = __webpack_public_path__ + "static/media/info_ikon.f35ce31f.svg";